import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import "./ProductLanding.scss";
import { baseUrl } from "../../../utils/apiData";

const ProductLanding = ({vendor, onClick}) => {
  return (
    <section className="product_landing">
      <div className="content_wrap p_top p_bottom">
        <div className="text_content">
          <p className="wow fadeInUp">{vendor?.main_heading || "-"}</p>
          <h1 className="small wow fadeInUp" data-wow-delay="0.1s">{vendor?.main_title || "-"}  </h1>
          <div className="btn_wrap wow fadeInUp" data-wow-delay="0.2s">
            <ArrowBtn
              text="Get in touch"
              handleClick={onClick}
              theme="secondary_ternery"
              classList="wow fadeInUp"

            />
         
          </div>
        </div>
        <div className="img_wrap">
            <img src={`${baseUrl}/${vendor?.main_image}`} alt="product" />
        </div>
      </div>
    </section>
  );
};

export default ProductLanding;
